import { View } from '@react-pdf/renderer';
import { NumericData } from '..';
import { SummaryItems } from '../../types';
import { styles } from './SummaryData.module';

interface SummaryDataProps {
  summaryItems: SummaryItems[];
}

export const SummaryData = ({ summaryItems }: SummaryDataProps) => {
  return (
    <View wrap>
      <View style={styles.dataSection} wrap={false}>
        {summaryItems?.map(
          (summaryItem) =>
            summaryItem.isVisible && (
              <NumericData
                key={summaryItem?.title}
                name={summaryItem?.title}
                amount={summaryItem?.value}
                amountStyle={summaryItem?.amountStyle}
                textStyle={summaryItem?.labelStyle}
                containerStyle={summaryItem?.containerStyle}
                isPartialPeriod={summaryItem.isPartialPeriod}
              />
            ),
        )}
      </View>
    </View>
  );
};
